export enum ProductAuditValueEnum {
	OK = 0,
	A = 1,
	B = 2,
	C = 3
}